<template>
  <settings>
    <loader v-if="loading"></loader>
    <section v-if="!loading">
      <div class="d-flex col-lg-12 justify-content-center my-md-5 pb-md-5 my-4">
        <b-row class="user-avatar mb-auto">
          <img
            v-if="userPhoto"
            :src="userPhoto"
            alt="profile image"
            class="profile-img rounded-circle imageSize"
          />
          <default-photo v-else class="imageSize"></default-photo>
          <smart-oee-photo-upload :profile="true" @uploaded="uploaded"></smart-oee-photo-upload>
        </b-row>
      </div>
      <div class="d-flex col-lg-12 justify-content-center">
        <div class="body-element-width">
          <smart-oee-profile-cards
            v-if="!editMode && user"
            :user="user"
            @editProfile="editProfile"
          />
          <smart-oee-profile-forms
            v-if="editMode && user"
            :user="user"
            @cancel="cancelForm"
            @save="saveForm"
          />
          <div class="mt-5">
            <div class="page-header mb-4">
              <p class="page-title">{{ $t('form.password.label') }}</p>
              <b-button
                v-if="!editModePassword"
                class="px-0"
                variant="transparent"
                @click="editModePassword = !editModePassword"
              >
                <svg-icon name="edit3" class="fill-icon icon-primary" size="24"></svg-icon>
              </b-button>
            </div>
            <div v-if="editModePassword">
              <password-popover @editPasswordClose="editPasswordClose"></password-popover>
            </div>
          </div>
        </div>
      </div>
    </section>
  </settings>
</template>

<script>
import DefaultPhoto from '@/assets/images/faces/user.svg';
import userInfoQuery from '@/api/user/userAllInfo.gql';
import defaultImage from '@/assets/images/samples/16.jpg';
import updateUserMutation from '@/api/user/mutations/updateProfile.gql';
import addUserPhoto from '@/api/user/mutations/addUserPhoto.gql';

export default {
  name: 'SettingsProfile',
  components: {
    DefaultPhoto,
  },
  data() {
    return {
      defaultImage: defaultImage,
      query: userInfoQuery,
      editMode: false,
      mutationLoading: false,
      editModePassword: false,
    };
  },
  computed: {
    loading() {
      return this.$apollo.queries.currentUser.loading || this.mutationLoading;
    },
    user() {
      return this.currentUser;
    },
    company() {
      return this.currentUser.itObject ? this.currentUser.itObject.name : '';
    },
    userPhoto() {
      return this.currentUser.attachmentPhoto ? this.currentUser.attachmentPhoto.url : '';
    },
  },
  apollo: {
    currentUser: {
      query() {
        return this.query;
      },
      deep: true,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.currentUser) {
          return {
            ...queryData.currentUser,
            login: this.$authCore.userLogin,
          };
        } else {
          return null;
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  methods: {
    uploaded(payload) {
      console.log(payload);

      this.$apollo
        .mutate({
          mutation: addUserPhoto,
          variables: {
            id: this.currentUser.id,
            fileName: payload.fileName,
            filePath: payload.filePath,
          },
          refetchQueries: [
            {
              query: userInfoQuery,
            },
          ],
        })
        .then(() => {
          this.$bvToast.toast(this.$t('settings.save'), {
            title: this.$t('toast.success'),
            variant: 'success',
            solid: true,
          });
        })
        .catch((e) => {
          this.$bvToast.toast(this.$t('settings.failSaved'), {
            title: this.$t('toast.error'),
            variant: 'danger',
            solid: true,
          });
          console.log(e.message);
        });
    },
    getImgBgStyle(img) {
      return {
        background: `url(${img}) no-repeat center`,
        'background-size': 'cover',
      };
    },
    cancelForm() {
      this.editMode = false;
    },
    saveForm(form) {
      this.mutationLoading = true;

      this.$apollo
        .mutate({
          mutation: updateUserMutation,
          variables: {
            editParams: {
              id: form.id,
              firstName: form.firstName,
              lastName: form.secondName,
              email: form.login,
              phone: form.phone,
            },
          },
          refetchQueries: [
            {
              query: userInfoQuery,
            },
          ],
        })
        .then(() => {
          this.mutationLoading = false;
          this.editMode = false;
        })
        .catch((e) => {
          this.mutationLoading = false;
          console.log(e);
        });
    },
    editProfile() {
      this.editMode = true;
    },
    editPasswordClose() {
      this.editModePassword = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.imageSize {
  width: 176px;
  height: 176px;
}
.body-element-width {
  width: 100%;
}
@media (min-width: 432px) {
  .body-element-width {
    width: 432px;
  }
}
</style>
